export default __webpack_public_path__ + "static/media/About_2.537ffef8.png";